// gatsby-browser.js
import React from "react"
import { AuthProvider } from "./src/context/AuthContext"
import "./src/style/global.css"
import Clarity from "@microsoft/clarity" // Import the Microsoft Clarity library

export const wrapRootElement = ({ element }) => (
  <AuthProvider>{element}</AuthProvider>
)

const ClarityProjectID = "r3kfeo0mz1"

export const onInitialClientRender = () => {
  if (process.env.NODE_ENV === "production") {
    // Only run this in production mode
    Clarity.init(ClarityProjectID) // Initialize Microsoft Clarity with your project ID
  }
}
